<!-- 登录页 -->
<template>
    <div class="login-page">
        <!-- 左侧品牌区 -->
        <aside class="brand-panel">
            <span class="glow glow-1"></span>
            <span class="glow glow-2"></span>
            <div class="brand-top">
                <img class="brand-logo" src="../../assets/logo.png" alt="logo">
                <div>
                    <h1 class="brand-name">菲范物联平台</h1>
                    <p class="brand-tagline">智能物流 · 仓储 · 关务一体化</p>
                </div>
            </div>
            <div class="brand-hero">
                <h2>让每一票货物<br><em>全程可视、提速增效</em></h2>
                <p class="brand-desc">面向智能物流、仓储与关务的一体化工作台，数据驱动决策，协同高效流转。</p>
            </div>
            <div class="brand-features">
                <div class="feature">
                    <span class="feature-ic">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
                    </span>
                    <div class="feature-text"><b>智慧仓储</b><span>库位、库存、出入库全程可视</span></div>
                </div>
                <div class="feature">
                    <span class="feature-ic">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 3 6v6c0 5 4 8 9 10 5-2 9-5 9-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
                    </span>
                    <div class="feature-text"><b>关务协同</b><span>报关、核注、合规作业一体化</span></div>
                </div>
                <div class="feature">
                    <span class="feature-ic">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/></svg>
                    </span>
                    <div class="feature-text"><b>数据驱动</b><span>报表与预警，辅助高效运营决策</span></div>
                </div>
            </div>
        </aside>

        <!-- 右侧表单区 -->
        <main class="form-panel">
            <div class="form-card">
                <div class="form-head">
                    <div class="eyebrow">WELCOME BACK</div>
                    <h3>登录平台</h3>
                    <p>请输入账号信息，登录您的管理工作台</p>
                </div>
                <el-form class="login-form" @submit.native.prevent="login">
                    <div class="field">
                        <label class="field-label">用户名</label>
                        <el-input v-model.trim="loginForm.name" prefix-icon="el-icon-user" placeholder="请输入用户名"
                            clearable @keyup.enter.native="login"></el-input>
                    </div>
                    <div class="field">
                        <label class="field-label">密码</label>
                        <el-input v-model.trim="loginForm.pwd" type="password" prefix-icon="el-icon-lock"
                            placeholder="请输入密码" show-password @keyup.enter.native="login"></el-input>
                    </div>
                    <!-- <div class="login-options">
                        <label class="remember"><input type="checkbox" checked>记住我</label>
                        <span class="forgot">忘记密码？</span>
                    </div> -->
                    <el-button class="login-btn" type="primary" :loading="loginLoading" @click="login">登 录</el-button>
                </el-form>
            </div>
        </main>

        <!-- 底部备案信息 -->
        <div class="login-bottom">
            <el-link @click="toICP" :underline="false" type="info">鲁ICP备2025166943号-1</el-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 登录表单数据
            loginForm: {
                name: '',
                pwd: ''
            },
            // 登录请求中状态
            loginLoading: false,
        }
    },
    methods: {
        // 登录
        login() {
            // 防止重复提交
            if (this.loginLoading) {
                return
            }
            // 简单校验
            if (!this.loginForm.name || !this.loginForm.pwd) {
                this.$message.warning('请输入用户名和密码')
                return
            }
            this.loginLoading = true
            this.$api.login(this.loginForm.name, this.loginForm.pwd).then(res => {
                localStorage.setItem('token', res.token);
                localStorage.setItem('name', res.name);
                localStorage.setItem('phone', res.phone);
                localStorage.setItem('address', res.address);
                localStorage.setItem('company', res.company);
                localStorage.setItem('area', res.area);
                this.$router.push({ name: 'home' });
            }).finally(() => {
                this.loginLoading = false
            })
        },
        // 跳转ICP备案网站
        toICP() {
            const newWindow = window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
            if (newWindow) {
                newWindow.opener = null
                newWindow.focus()
            } else {
                alert('浏览器拦截了弹窗，请允许后重试')
            }
        }
    }
}
</script>

<style lang="less" scoped>
/* ===== 登录页整体：分屏布局 ===== */
.login-page {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: stretch;
    overflow: hidden;
    font-family: -apple-system, "PingFang SC", "Microsoft YaHei", "Segoe UI", Roboto, sans-serif;
}

/* ===== 左侧品牌区 ===== */
.brand-panel {
    position: relative;
    flex: 0 0 44%;
    overflow: hidden;
    color: #ffffff;
    padding: 60px 56px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(160deg, #2a0608 0%, #4a0d10 48%, #8f1a1a 100%);
}
.brand-panel .glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(2px);
    opacity: 0.5;
}
.brand-panel .glow-1 {
    width: 420px;
    height: 420px;
    background: radial-gradient(circle, rgba(231, 68, 5, 0.55), transparent 70%);
    top: -120px;
    right: -120px;
}
.brand-panel .glow-2 {
    width: 460px;
    height: 460px;
    background: radial-gradient(circle, rgba(255, 180, 120, 0.28), transparent 70%);
    bottom: -160px;
    left: -140px;
}
.brand-top {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 14px;
}
.brand-top .brand-logo {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}
.brand-name {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #ffffff;
}
.brand-tagline {
    margin: 4px 0 0;
    font-size: 13px;
    opacity: 0.72;
    letter-spacing: 1px;
    color: #ffffff;
}
.brand-hero {
    position: relative;
    z-index: 2;
}
.brand-hero h2 {
    margin: 0;
    font-size: 34px;
    font-weight: 600;
    line-height: 1.35;
    max-width: 360px;
    color: #ffffff;
}
.brand-hero h2 em {
    font-style: normal;
    color: #ff7a3d;
}
.brand-hero .brand-desc {
    margin: 16px 0 0;
    font-size: 15px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.72);
    max-width: 340px;
}
.brand-features {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.brand-features .feature {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}
.brand-features .feature-ic {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}
.brand-features .feature-text b {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
}
.brand-features .feature-text span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.62);
}

/* ===== 右侧表单区 ===== */
.form-panel {
    flex: 1 1 56%;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
}
.form-card {
    width: 100%;
    max-width: 400px;
}
.form-head {
    margin-bottom: 32px;
}
.form-head .eyebrow {
    color: #e74405;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
}
.form-head h3 {
    margin: 8px 0 0;
    font-size: 28px;
    font-weight: 600;
    color: #2c3e50;
}
.form-head p {
    margin-top: 8px;
    font-size: 14px;
    color: #8a9ab0;
}

/* 表单字段 */
.field {
    margin-bottom: 20px;
}
.field-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    margin-bottom: 8px;
}
.field ::v-deep .el-input__inner {
    width: 100%;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    border-radius: 10px;
    border: 1px solid #e7e9ee;
    background: #fbfcfe;
    color: #1f2937;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.field ::v-deep .el-input__inner::placeholder {
    color: #b0b7c3;
}
.field ::v-deep .el-input__inner:focus {
    border-color: #e74405;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(231, 68, 5, 0.28);
}

/* 记住我 / 忘记密码 */
.login-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 0 24px;
}
.remember {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #6b7280;
    cursor: pointer;
}
.remember input {
    width: 16px;
    height: 16px;
    accent-color: #e74405;
}
.forgot {
    font-size: 14px;
    font-weight: 500;
    color: #e74405;
    cursor: pointer;
}

/* 登录按钮 */
.login-btn {
    width: 100%;
    height: 48px;
    margin-top: 4px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 6px;
    border-radius: 10px;
    background: linear-gradient(90deg, #e74405, #f2612a);
    border-color: transparent;
    box-shadow: 0 10px 24px rgba(231, 68, 5, 0.28);
    transition: transform 0.12s, box-shadow 0.2s;
    margin-top: 20px;
}
.login-btn:hover,
.login-btn:focus {
    background: linear-gradient(90deg, #e74405, #f2612a);
    opacity: 1;
    transform: translateY(-1px);
    box-shadow: 0 14px 30px rgba(231, 68, 5, 0.34);
}

/* ===== 底部备案 ===== */
.login-bottom {
    position: fixed;
    bottom: 16px;
    left: 50%;
    right: 0;
    text-align: center;
    z-index: 1;
}
.login-bottom .el-link {
    color: rgba(42, 6, 8, 0.45);
}

/* 小屏适配：隐藏品牌区，表单居中 */
@media (max-width: 900px) {
    .login-page {
        flex-direction: column;
    }
    .brand-panel {
        display: none;
    }
    .form-panel {
        flex: 1 1 auto;
        padding: 32px 24px;
    }
    .login-bottom {
        left: 0;
    }
}
</style>
